document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'gccWishlist';

  function getWishlist() {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));

      if (!Array.isArray(stored)) {
        return [];
      }

      return stored;
    } catch (error) {
      return [];
    }
  }

function updateHeaderWishlistCount() {
  const countElement = document.querySelector(
    '.gcc-header-wishlist__count'
  );

  if (!countElement) return;

  const count = getWishlist().length;

  countElement.textContent = count;

  if (count > 0) {
    countElement.hidden = false;
  } else {
    countElement.hidden = true;
  }
}

  function saveWishlist(wishlist) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
  updateHeaderWishlistCount();
}

  function isProductSaved(wishlist, productId) {
    return wishlist.some(function (item) {
      if (typeof item === 'string') {
        return item === productId;
      }

      return String(item.id) === String(productId);
    });
  }

  function updateButton(button, isActive) {
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  }

  updateHeaderWishlistCount();

  document
    .querySelectorAll('.gcc-premium-product-card__wishlist')
    .forEach(function (button) {
      const productId = String(button.dataset.productId || '');
      const productHandle = button.dataset.productHandle || '';

      if (!productId) return;

      let wishlist = getWishlist();

      updateButton(
        button,
        isProductSaved(wishlist, productId)
      );

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        wishlist = getWishlist();

        const alreadySaved = isProductSaved(
          wishlist,
          productId
        );

        if (alreadySaved) {
          wishlist = wishlist.filter(function (item) {
            if (typeof item === 'string') {
              return item !== productId;
            }

            return String(item.id) !== productId;
          });

          updateButton(button, false);
        } else {
          wishlist.push({
            id: productId,
            handle: productHandle
          });

          updateButton(button, true);
        }

        saveWishlist(wishlist);
      });
    });
});